import { render, staticRenderFns } from "./modalReferensiPengirim.vue?vue&type=template&id=4d68dd2c&"
import script from "./modalReferensiPengirim.vue?vue&type=script&lang=js&"
export * from "./modalReferensiPengirim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports